import { Outlet, createFileRoute } from '@tanstack/react-router';
import { ProductLogoMediumLicenses as LogoLicenses } from '@/components/Logo';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import { MOCK_ONLY_FEATURE_FLAG } from '@/constants/featureFlags';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { featureFlags } from '@/lib/env';
import { useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/licenses/_list')({
  component: LicensesLayout
});
function LicensesLayout() {
  const {
    t
  } = useTranslation();
  useDocumentTitle(t('pages.licenses.title'));

  // デモ用モック: 契約&コストはソフトウェア側に集約するため、MOCK_ONLY 有効時は
  // ライセンス配下の「契約&コスト」タブを非表示にする（本番は従来どおり表示）。
  const hidesContractAndCost = featureFlags.check(MOCK_ONLY_FEATURE_FLAG);
  const tabs = [{
    to: '/licenses',
    children: t('common.list.overview'),
    activeOptions: {
      exact: true
    }
  }, {
    to: '/licenses/inventory',
    children: t('common.list.licenses.inventory')
  }, {
    to: '/licenses/people',
    children: t('common.list.people')
  }, {
    to: '/licenses/alerts',
    children: t('common.list.alerts')
  }, ...(hidesContractAndCost ? [] : [{
    to: '/licenses/contract-and-cost',
    children: t('common.list.contractAndCost')
  }] satisfies TabWithIndicatorProps[]), {
    to: '/licenses/operation-activity',
    children: t('common.list.operationActivity')
  }, {
    to: '/licenses/rule-and-policy',
    children: t('common.list.ruleAndPolicy')
  }, {
    to: '/licenses/settings',
    children: t('common.list.settings')
  }] satisfies TabWithIndicatorProps[];
  return <div className="flex flex-col">
      <ProductHeader Logo={LogoLicenses} name={t('pages.licenses.title')} tabs={tabs} type="resource" />
      <Outlet />
    </div>;
}